import {Component, inject, Signal} from '@angular/core';

import {AppConfigFacade} from '@selpia/app-config/data-access';
import {DropdownComponent, LoaderComponent} from '@selpia/shared/ui';
import {OptionsFacade} from '@selpia/options/data-access';
import {NavigationService} from '@selpia/data-batch/history-access';
import {MonitoringService} from '@selpia/user/tracking';

@Component({
  selector: 'lib-feature-period-selector',
  imports: [DropdownComponent, LoaderComponent],
  templateUrl: './feature-period-selector.component.html',
  styleUrl: './feature-period-selector.component.css',
})
export class FeaturePeriodSelectorComponent {
  readonly #appConfigFacade = inject(AppConfigFacade);
  readonly #optionsFacade = inject(OptionsFacade);
  readonly #navigationService = inject(NavigationService);
  readonly #monitoringService = inject(MonitoringService);

  protected readonly isLoading: Signal<boolean> = this.#appConfigFacade.isLoading;

  protected readonly availablePeriods: Signal<string[]> = this.#appConfigFacade.periods;
  protected readonly focusPeriod: Signal<string | undefined> = this.#optionsFacade.focusPeriod;

  updateFocusPeriod(period: string | undefined) {
    if (period) {
      this.#navigationService.setFocusPeriod(period);
      this.#monitoringService.logEvent('PeriodChanged', {period: period, view: "Tilegrid"});//dodałem logowanie tutaj, bo jak zrobiłem w html z użyciem AnalyticsDirective to logowało mi kliknięcie w dropdown dwa razy
    }
  }
}
